import { Container, Grid, Text, useColorMode } from "theme-ui";
import ProjectOverviewCard from "./ProjectOverviewCard";
import GreenUpArrow from "../../../../assets/images/greenUpArrow.png";
import RedDownArrow from "../../../../assets/images/redDownArrow.png";
import { ProjectOverviewProps } from "../../../../../types/dashboard.types";
import React from "react";

const getDifferencePercentage = (total: number | null, diff: number | null): any => {
    if (!total || !diff) return 0;
    const percent = ((diff / total) * 100).toFixed(2);
    return percent
};

const getArrow = (status: string | null) =>
    status === "down" ? RedDownArrow : GreenUpArrow;

const ProjectOverview = ({ projectOverview, loading }: ProjectOverviewProps) => {
    const {
        approvedCountData,
        deliveredProjectsData,
        inProgressProjectsData,
        onHoldProjectsData,
    } = projectOverview ?? {}

    // Build dynamic card list
    const cards = [
        {
            title: "Approved Projects",
            data: approvedCountData,
            description: "Projects with a status other than “Draft”.",
        },
        {
            title: "Done Projects",
            data: deliveredProjectsData,
            description: "Projects with status “Delivered”."
        },
        {
            title: "In Progress",
            data: inProgressProjectsData,
            description: "Projects with status other than “Draft” and “Delivered”."
        },
        {
            title: "On Hold Projects",
            data: onHoldProjectsData,
            description: "Projects with the status “On Hold”."
        },
    ];
    const [colorMode] = useColorMode();
    const bgDashboard = colorMode === 'light' ? "#ffffff" : "#2e354db8";
    const titleHeader = colorMode === 'light' ? "#453521" : "#f8f9fa";
    return (
        <Container
            sx={{
                borderRadius: "20px",
                background: bgDashboard,
                p: "20px",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
            }}
        >
            <Text sx={{ color: titleHeader, fontSize: ["14px", "18px"], fontWeight: 700, mb: 2 }}>
                Project Overview
            </Text>

            <Grid gap={4} columns={[1, 2, 2, 4]} sx={{ width: "100%" }}>
                {cards.map(({ title, data, description }: { title: string | null, data: null | any, description: null | string }) => {

                    return <ProjectOverviewCard
                        key={title}
                        loading={loading}
                        title={title}
                        value={data?.total}
                        meta={{
                            arrow: getArrow(data?.status),
                            difference: data?.difference,
                            percentage: data?.percentage,
                            differencePercentage: data?.diffPercentage,
                            status: data?.status,
                            description: description
                        }}
                        colorMode={colorMode}
                    />
                })}
            </Grid>
        </Container>
    );
};

export default React.memo(ProjectOverview);
